<div class="bg-white  items-center text-center mx-auto rounded-2xl border-2 border-lightGray2 shadow-sm" [ngClass]="padding">
  <app-loader size="large" *ngIf="showLoading"></app-loader>
  <div *ngIf="!showLoading">
    <ng-content ></ng-content>
  </div>
</div>
